import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit {
  @Input() bread: Array<[]>;
  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToUrl(url, params) {
    if (url == null) {
      window.history.back();
      return false;
    }
    else {
      this.router.navigate([url], {queryParams: params});
    }
  }

}
